/**
 * Extracted from marketplaceItemSchema.ts to avoid circular dependency:
 * marketplaceItemSchema → collectibles barrel → collectiblesHelpers → collection/item barrel → collectionItemSchema → marketplaceItemSchema
 */
import { WholeNumber_Schema } from "@/utilities/schema";
import { z } from "zod";

export const MarketplaceItemId_Schema = WholeNumber_Schema;

export const MarketplaceItemBasics_Schema = z.object({
  id: MarketplaceItemId_Schema,
  name: z.string(),
  quantity: WholeNumber_Schema,
});
